import React, { useState } from 'react'
import { Query, Mutation } from 'react-apollo'
import { useQuery } from '@apollo/react-hooks'
import _ from 'lodash'
import moment from 'moment'
import numeral from 'numeral'
import {
  Div, H4, P, InputWithLabel, Loading,
} from 'konsys-ui'
import {
  DatePicker, Row, Col, message, Collapse,
} from 'antd'
import { theme } from '../../../styles/_variables'
import detailType, { RemarksDetailModeHandler, isLatedMoreThan15days } from '../util-functions'
import { fuelTypeList, statusList } from '../../filling-order-page/detail/component-renderer'
import {
  detailMode, status, dealType, dealTypeText, unitValue,
} from '../constants'
import { GET_JOB, SHIPPING_ORDER } from '../../../constants/graphql/query'
import { colorSelector, textStatusSelector } from '../list/table'
import { mappingValueToTypeText } from '../../../components/filling-order-components'

const dealTypeSelector = (e) => {
  switch (e) {
    case dealType.PERTRIP:
      return dealTypeText.PERTRIP
    case dealType.PERWEIGHT:
      return dealTypeText.PERWEIGHT
    default:
      return 'ไม่ระบุ'
  }
}

const { color } = theme

const customPanelStyle = {
  background: '#f7f7f7',
  borderRadius: 4,
  marginBottom: 24,
  border: 0,
  overflow: 'hidden',
}

const DriverShippingDetail = ({ props }) => {
  const {
    data, loading, error,
  } = useQuery(SHIPPING_ORDER, { variables: { id: props.match.params.id } })
  if (loading || _.isEmpty(data)) return <Loading center='true' />
  if (error) return <P>เกิดข้อผิดพลาด</P>
  const haveAssign = !_.isUndefined(data.ShippingorderInfo) && !_.isNull(data.ShippingorderInfo.Driver.id)
  const haveFuel = !_.isUndefined(data.ShippingorderInfo) && !_.isNull(data.ShippingorderInfo.FuelOrder.id)
  const haveDelivery = !_.isUndefined(data.ShippingorderInfo) && !_.isNull(data.ShippingorderInfo.deliveryDate)

  const mappingValueToStatusText = (value) => {
    if (_.isUndefined(value)) return 'ไม่ระบุ'
    const mapped = _.find(statusList, o => o.value === value.FuelOrder.status)
    return (
      _.isUndefined(mapped) ? 'ไม่ระบุ' : mapped.text
    )
  }

  const mappingValueToStatusColor = (value) => {
    if (_.isUndefined(value)) return 'ไม่ระบุ'
    const mapped = _.find(statusList, o => o.value === value.FuelOrder.status)
    return (
      !_.isUndefined(mapped) && mapped.color
    )
  }

  const style = {
    margin: '0 16px 0 0', width: '100%',
  }

  const expensesHighway = !_.isUndefined(data.ShippingorderInfo.expensesHighway) ? data.ShippingorderInfo.expensesHighway : 0
  const expensesEntrance = !_.isUndefined(data.ShippingorderInfo.expensesEntrance) ? data.ShippingorderInfo.expensesEntrance : 0
  const expensesPickup = !_.isUndefined(data.ShippingorderInfo.expensesPickup) ? data.ShippingorderInfo.expensesPickup : 0
  const expensesOther = !_.isUndefined(data.ShippingorderInfo.expensesOther) ? data.ShippingorderInfo.expensesOther : 0
  const feePickupHeavy = !_.isUndefined(data.ShippingorderInfo.feePickupHeavy) ? data.ShippingorderInfo.feePickupHeavy : 0
  const feePierEntrance = !_.isUndefined(data.ShippingorderInfo.feePierEntrance) ? data.ShippingorderInfo.feePierEntrance : 0
  const feePickupNormal = !_.isUndefined(data.ShippingorderInfo.feePickupNormal) ? data.ShippingorderInfo.feePickupNormal : 0
  const feeOther = !_.isUndefined(data.ShippingorderInfo.feeOther) ? data.ShippingorderInfo.feeOther : 0

  return (
    <Div>
      {/* ================== Section 1 ================== */}
      <Div
        display='flex'
        flexDirection='column'
        alignItems='center'
        justifyContent={'flex-end'}
        padding='32px 0 40px 0'
        style={{ borderBottom: `1px solid ${color.paleGrey}` }}
      >
        <Div display='flex' flexDirection='column' margin='0 0 16px'>
          {/* <H4 bold>Ref ID - {data.ShippingorderInfo.shippingCode}</H4>
          <P bold>วันที่สร้าง - {moment(data.ShippingorderInfo.Job.createdAt).format('DD MMMM YYYY')}</P> */}
          <Div margin='8px 0 16px'>
            <P bold>สถานะการขนส่ง:&nbsp;</P><H4 bold color={colorSelector(data.ShippingorderInfo.status)}>{textStatusSelector(data.ShippingorderInfo.status)}</H4>
          </Div>
        </Div>
        <Div display='flex' width='100%' margin='0 0 16px'>
          <Col span={12}>
            <Row style={{ marginBottom: 8 }}>
              <Col span={24}>
                <P>เล่มที่ *</P>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <P>{data.ShippingorderInfo.shippingVolume}</P>
              </Col>
            </Row>
          </Col>
          <Col span={12}>
            <Row style={{ marginBottom: 8 }}>
              <Col span={24}>
                <P>เลขที่ *</P>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <P>{data.ShippingorderInfo.shippingNumber}</P>
              </Col>
            </Row>
          </Col>
        </Div>
        <Div display='flex' width='100%'>
          <Col span={12}>
            <Row style={{ marginBottom: 8 }}>
              <Col span={24}>
                <P>วันที่ครบกำหนด *</P>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <P>{moment(data.ShippingorderInfo.assignDate).format('YYYY/MM/DD')}</P>
              </Col>
            </Row>
          </Col>
        </Div>
      </Div>
      {/* ================== Section 2 ================== */}
      {/* <Row align='flex-start' type='flex' gutter={12} style={{ borderBottom: `1px solid ${color.paleGrey}`, padding: '32px 0 40px' }}>
        <Col span={24}>
          <Row style={{ marginBottom: 8 }}>
            <Col span={24}>
              <P>ผู้จ้าง</P>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <P>{_.isUndefined(data.ShippingorderInfo.Customer) ? '' : data.ShippingorderInfo.Customer.companyName} {_.isUndefined(data.ShippingorderInfo.Customer) ? '' : data.ShippingorderInfo.Customer.branch}</P>
            </Col>
          </Row>
        </Col>
      </Row> */}
      <Row align='flex-start' type='flex' gutter={12} style={{ borderBottom: `1px solid ${color.paleGrey}`, padding: '32px 0 40px' }}>
        <Div display='flex' flexDirection='column'>
          <Col span={24} style={{ margin: '0 0 16px' }}>
            <Row style={{ marginBottom: 8 }}>
              <Col span={24}>
                <P>ขนจาก (ต้นทาง) *</P>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <P>{_.isUndefined(data.ShippingorderInfo.startDestinationLocation) ? '' : data.ShippingorderInfo.startDestinationLocation.name}</P>
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <Row style={{ marginBottom: 8 }}>
              <Col span={24}>
                <P>ขนไป (ปลายทาง) *</P>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <P>{_.isUndefined(data.ShippingorderInfo.endDestinationLocation) ? '' : data.ShippingorderInfo.endDestinationLocation.name}</P>
              </Col>
            </Row>
          </Col>
        </Div>
      </Row>
      <Row align='flex-start' type='flex' gutter={12} style={{ borderBottom: `1px solid ${color.paleGrey}`, padding: '32px 0 40px' }}>
        <Div display='flex' flexDirection='column'>
          <Col span={24} style={{ margin: '0 0 16px' }}>
            <Row style={{ marginBottom: 8 }}>
              <Col span={24}>
                <P>เบี้ยเลี้ยง *</P>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <P>{data.ShippingorderInfo.compensation} บาท</P>
              </Col>
            </Row>
          </Col>
        </Div>
      </Row>
      {/* ================== Assign Driver section ================== */}
      {haveAssign
        && <Div padding='40px 0' style={{ borderBottom: `1px solid ${color.paleGrey}` }}>
          <Div display='flex' flexDirection='column'>
            <H4 bold color={theme.color.primaryColor} margin='0 0 16px 0'>จ่ายงาน</H4>
            <Col span={24} style={{ margin: '0 0 16px' }}>
              <Row style={{ marginBottom: 8 }}>
                <Col span={24}>
                  <P>ทะเบียนรถ *</P>
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <P>{_.isUndefined(data.ShippingorderInfo.Truck) ? '' : data.ShippingorderInfo.Truck.plateNumber}</P>
                </Col>
              </Row>
            </Col>
            <Col span={24} style={{ margin: '0 0 16px' }}>
              <Row style={{ marginBottom: 8 }}>
                <Col span={24}>
                  <P>พนักงานขับรถ *</P>
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <P>{data.ShippingorderInfo.Driver.fullname}</P>
                </Col>
              </Row>
            </Col>
            <Col span={24} style={{ margin: '0 0 16px' }}>
              <Row style={{ marginBottom: 8 }}>
                <Col span={24}>
                  <P>เวลาออก *</P>
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <P>{_.isUndefined(data.ShippingorderInfo.startTime) ? '' : moment(data.ShippingorderInfo.startTime).format('YYYY/MM/DD HH:mm:ss')}</P>
                </Col>
              </Row>
            </Col>
          </Div>
        </Div>
      }
      {/* ================== Assign Filling section ================== */}
      {haveFuel
        && < Div padding='40px 0' style={{ borderBottom: `1px solid ${color.paleGrey}` }}>
          <Div display='flex' flexDirection='column'>
            <H4 bold color={theme.color.primaryColor} margin='0 0 16px 0'>ใบเบิกน้ำมัน</H4>
            <Col span={24} style={{ margin: '0 0 16px' }}>
              <Row style={{ marginBottom: 8 }}>
                <Col span={24}>
                  <P>ปั๊มน้ำมัน *</P>
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <P>{_.isUndefined(data.ShippingorderInfo.FuelOrder.Gasstation) ? '' : data.ShippingorderInfo.FuelOrder.Gasstation.name}</P>
                </Col>
              </Row>
            </Col>
            <Div display='flex' width='100%'>
              <Col span={12} style={{ margin: '0 0 16px' }}>
                <Row style={{ marginBottom: 8 }}>
                  <Col span={24}>
                    <P>ทั้งหมด *</P>
                  </Col>
                </Row>
                <Row>
                  <Col span={24}>
                    <P>{data.ShippingorderInfo.FuelOrder.totalAmount} ลิตร</P>
                  </Col>
                </Row>
              </Col>
              <Col span={12} style={{ margin: '0 0 16px' }}>
                <Row style={{ marginBottom: 8 }}>
                  <Col span={24}>
                    <P>ประเภทเชื้อเพลิง *</P>
                  </Col>
                </Row>
                <Row>
                  <Col span={24}>
                    <P>{mappingValueToTypeText(data.ShippingorderInfo.FuelOrder.fuelType)}</P>
                  </Col>
                </Row>
              </Col>
            </Div>
            <Col span={24} style={{ margin: '0 0 16px' }}>
              <Row style={{ marginBottom: 8 }}>
                <Col span={24}>
                  <P>วันหมดอายุ *</P>
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <P>{_.isUndefined(data.ShippingorderInfo.FuelOrder.expiredDate) ? '' : moment(data.ShippingorderInfo.expiredDate).format('YYYY/MM/DD')}</P>
                </Col>
              </Row>
            </Col>
            <Div display='flex' width='100%' margin='0 0 16px'>
              <Col span={12} style={{ margin: '0 0 16px' }}>
                <Row style={{ marginBottom: 8 }}>
                  <Col span={24}>
                    <P>สถานะ</P>
                  </Col>
                </Row>
                <Row>
                  <Col span={24}>
                    <P color={mappingValueToStatusColor(data.ShippingorderInfo)} bold>{mappingValueToStatusText(data.ShippingorderInfo)}</P>
                  </Col>
                </Row>
              </Col>
              <Col span={12} style={{ margin: '0 0 16px' }}>
                <Row style={{ marginBottom: 8 }}>
                  <Col span={24}>
                    <P>ปริมาณที่เติมแล้ว</P>
                  </Col>
                </Row>
                <Row>
                  <Col span={24}>
                    <P>{numeral(data.ShippingorderInfo.FuelOrder.filledAmount).format('0,0.00')} ลิตร</P>
                  </Col>
                </Row>
              </Col>
            </Div>
          </Div>
        </Div>
      }
      {/* ================== Record section ================== */}
      {
        haveDelivery
        && (data.ShippingorderInfo.Job.dealType === 'PERTRIP'
          ? <Div padding='40px 0' style={{ borderBottom: `1px solid ${color.paleGrey}` }}>
            <Div display='flex' flexDirection='column'>
              <H4 bold color={theme.color.primaryColor} margin='0 0 16px 0'>บันทึกการขนส่ง - แบบเที่ยว</H4>
              <Col span={24} style={{ margin: '0 0 16px' }}>
                <Row style={{ marginBottom: 8 }}>
                  <Col span={24}>
                    <P>วันที่นำส่ง *</P>
                  </Col>
                </Row>
                <Row>
                  <Col span={24}>
                    <P>{moment(data.ShippingorderInfo.deliveryDate).format('YYYY/MM/DD')} {data.ShippingorderInfo.deliveryTime.slice(0, -3)}</P>
                  </Col>
                </Row>
              </Col>
              <Col span={24} style={{ margin: '0 0 16px' }}>
                <Row style={{ marginBottom: 8 }}>
                  <Col span={24}>
                    <P>เลขที่ใบนำส่ง *</P>
                  </Col>
                </Row>
                <Row>
                  <Col span={24}>
                    <P>{data.ShippingorderInfo.weightRecordId}</P>
                  </Col>
                </Row>
              </Col>
              <Div display='flex' width='100%' margin='0 0 16px'>
                <Col span={12} style={{ margin: '0 0 16px' }}>
                  <Row style={{ marginBottom: 8 }}>
                    <Col span={24}>
                      <P>จำนวนกระสอบเปล่า</P>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={24}>
                      <P>{data.ShippingorderInfo.emptySackAmount ? data.ShippingorderInfo.emptySackAmount : '-'}</P>
                    </Col>
                  </Row>
                </Col>
                <Col span={12} style={{ margin: '0 0 16px' }}>
                  <Row style={{ marginBottom: 8 }}>
                    <Col span={24}>
                      <P>ค่าขนส่ง *</P>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={24}>
                      <P>{numeral(data.ShippingorderInfo.feeTotal).format('0,0.00')} บาท</P>
                    </Col>
                  </Row>
                </Col>
              </Div>
              <Div display='flex' width='100%' margin='0 0 16px'>
                <Col span={12} style={{ margin: '0 0 16px' }}>
                  <Row style={{ marginBottom: 8 }}>
                    <Col span={24}>
                      <P>ค่าเที่ยวต่างจังหวัด</P>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={24}>
                      <P>{numeral(data.ShippingorderInfo.outTownFeeRate).format('(0,0.00)')} บาท</P>
                    </Col>
                  </Row>
                </Col>
                <Col span={12} style={{ margin: '0 0 16px' }}>
                  <Row style={{ marginBottom: 8 }}>
                    <Col span={24}>
                      <P>ค่าเที่ยวพิเศษ</P>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={24}>
                      <P>{numeral(data.ShippingorderInfo.specialFeeRate).format('0,0.00')} บาท</P>
                    </Col>
                  </Row>
                </Col>
              </Div>
              <Row>
                <Col span={24}>
                  <P bold margin='16px 6px'>วันที่บันทึกการขนส่ง: {moment(data.ShippingorderInfo.recordDate).format('DD MMMM YYYY')}</P>
                </Col>
              </Row>
            </Div>
          </Div>
          : <Div padding='40px 0' style={{ borderBottom: `1px solid ${color.paleGrey}` }}>
            <Div display='flex' flexDirection='column'>
              <H4 bold color={theme.color.primaryColor} margin='0 0 16px 0'>บันทึกการขนส่ง - แบบน้ำหนัก</H4>
              <Col span={24} style={{ margin: '0 0 16px' }}>
                <Row style={{ marginBottom: 8 }}>
                  <Col span={24}>
                    <P>วันที่นำส่ง *</P>
                  </Col>
                </Row>
                <Row>
                  <Col span={24}>
                    <P>{moment(data.ShippingorderInfo.deliveryDate).format('YYYY/MM/DD')} {data.ShippingorderInfo.deliveryTime.slice(0, -3)}</P>
                  </Col>
                </Row>
              </Col>
              <Col span={24} style={{ margin: '0 0 16px' }}>
                <Row style={{ marginBottom: 8 }}>
                  <Col span={24}>
                    <P>เลขที่ใบนำส่ง *</P>
                  </Col>
                </Row>
                <Row>
                  <Col span={24}>
                    <P>{data.ShippingorderInfo.weightRecordId}</P>
                  </Col>
                </Row>
              </Col>
              <Div display='flex' width='100%' margin='0 0 16px'>
                <Col span={12} style={{ margin: '0 0 16px' }}>
                  <Row style={{ marginBottom: 8 }}>
                    <Col span={24}>
                      <P>น้ำหนักต้นทาง *</P>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={24}>
                      <P>{numeral(data.ShippingorderInfo.startWeight).format('0,0.00')} กิโลกรัม</P>
                    </Col>
                  </Row>
                </Col>
                <Col span={12} style={{ margin: '0 0 16px' }}>
                  <Row style={{ marginBottom: 8 }}>
                    <Col span={24}>
                      <P>น้ำหนักปลายทาง *</P>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={24}>
                      <P>{numeral(data.ShippingorderInfo.endWeight).format('0,0.00')} กิโลกรัม</P>
                    </Col>
                  </Row>
                </Col>
              </Div>
              <Div display='flex' width='100%' margin='0 0 16px'>
                <Col span={12} style={{ margin: '0 0 16px' }}>
                  <Row style={{ marginBottom: 8 }}>
                    <Col span={24}>
                      <P>น้ำหนักขาดเกิน</P>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={24}>
                      <P>{!_.isNaN(parseFloat(data.ShippingorderInfo.startWeight)) && !_.isNaN(parseFloat(data.ShippingorderInfo.endWeight)) && numeral(parseFloat(data.ShippingorderInfo.endWeight) - parseFloat(data.ShippingorderInfo.startWeight)).format('(0,0.00)')} กิโลกรัม</P>
                    </Col>
                  </Row>
                </Col>
                <Col span={12} style={{ margin: '0 0 16px' }}>
                  <Row style={{ marginBottom: 8 }}>
                    <Col span={24}>
                      <P>{data.ShippingorderInfo.unit === unitValue.TRIP ? 'เที่ยวที่คิดเงิน' : 'น้ำหนักที่คิดเงิน'}</P>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={24}>
                      <P>{data.ShippingorderInfo.unit === unitValue.TRIP ? `${numeral(data.ShippingorderInfo.roundWeight).format('0,0.00')} เที่ยว` : `${numeral(data.ShippingorderInfo.roundWeight).format('0,0.00')} กิโลกรัม`}</P>
                    </Col>
                  </Row>
                </Col>
              </Div>
              <Row>
                <Col span={24}>
                  <P bold margin='16px 6px'>วันที่บันทึกการขนส่ง: {moment(data.ShippingorderInfo.recordDate).format('DD MMMM YYYY')}</P>
                </Col>
              </Row>
            </Div>
          </Div>
        )
      }
      {/* ================== Remarks section ================== */}
      < Div padding='40px 0' style={{ borderBottom: `1px solid ${color.paleGrey}` }}>
        <Div display='flex' flexDirection='column'>
          {/* <Row align='flex-start' type='flex' gutter={12} style={{ margin: '24px 0 0 0' }}>
      <Col span={24}>
        <Collapse bordered={false} defaultActiveKey='expense'>
          <Collapse.Panel style={customPanelStyle} header={`ค่าใช้จ่ายทั้งหมด: ${numeral(toSafeFloat(expensesEntrance) + toSafeFloat(expensesHighway) + toSafeFloat(expensesOther) + toSafeFloat(expensesPickup)).format('0,0.00')} บาท`} key="expense">
            <InputWithLabelAndUnitOneRow
              margin='0 0 16px 0'
              data={{
                disabled: true,
                value: numeral(expensesHighway).format('0,0.00'),
                id: 'expensesHighway',
                unit: 'บาท',
                props: { ...style, title: { text: 'ค่าทางด่วน' } },
              }}
            />
            <InputWithLabelAndUnitOneRow
              margin='0 0 16px 0'
              data={{
                disabled: true,
                value: numeral(expensesEntrance).format('0,0.00'),
                id: 'expensesEntrance',
                unit: 'บาท',
                props: { ...style, title: { text: 'ค่าเหยียบลาน' } },
              }}
            />
            <InputWithLabelAndUnitOneRow
              margin='0 0 16px 0'
              data={{
                disabled: true,
                value: numeral(expensesPickup).format('0,0.00'),
                id: 'expensesPickup',
                unit: 'บาท',
                props: { ...style, title: { text: 'ค่าขึ้นค่าลง' } },
              }}
            />
            <InputWithLabelAndUnitOneRow
              margin='0 0 16px 0'
              data={{
                disabled: true,
                value: numeral(expensesOther).format('0,0.00'),
                id: 'expensesOther',
                unit: 'บาท',
                props: { ...style, title: { text: 'อื่นๆ' } },
              }}
            />
          </Collapse.Panel>
        </Collapse>
      </Col>
      </Row>
      <Row align='flex-start' type='flex' gutter={12} style={{ margin: '24px 0 0 0' }}>
      <Col span={24}>
        <Collapse bordered={false} defaultActiveKey='tariff'>
          <Collapse.Panel
            style={customPanelStyle}
            header={`ค่าธรรมเนียม (เบิกกับลูกค้า) ทั้งหมด: ${numeral(toSafeFloat(feePierEntrance) + toSafeFloat(feePickupNormal) + toSafeFloat(feePickupHeavy) + toSafeFloat(feeOther)).format('0,0.00')} บาท`}
            key="tariff"
          >
            <InputWithLabelAndUnitOneRow
              margin='0 0 16px 0'
              data={{
                disabled: true,
                value: numeral(feePickupHeavy).format('0,0.00'),
                id: 'feePickupHeavy',
                unit: 'บาท',
                props: { ...style, title: { text: 'ค่ายกตู้หนัก' } },
              }}
            />
            <InputWithLabelAndUnitOneRow
              margin='0 0 16px 0'
              data={{
                disabled: true,
                value: numeral(feePierEntrance).format('0,0.00'),
                id: 'feePierEntrance',
                unit: 'บาท',
                props: { ...style, title: { text: 'ค่าผ่านท่าเรือ' } },
              }}
            />
            <InputWithLabelAndUnitOneRow
              margin='0 0 16px 0'
              data={{
                disabled: true,
                value: numeral(feePickupNormal).format('0,0.00'),
                id: 'feePickupNormal',
                unit: 'บาท',
                props: { ...style, title: { text: 'ค่ายกตู้เปล่า' } },
              }}
            />
            <InputWithLabelAndUnitOneRow
              margin='0 0 16px 0'
              data={{
                disabled: true,
                value: numeral(feeOther).format('0,0.00'),
                id: 'feeOther',
                unit: 'บาท',
                props: { ...style, title: { text: 'อื่นๆ' } },
              }}
            />
          </Collapse.Panel>
        </Collapse>
      </Col>
    </Row> */}
          <Div display='flex' width='100%'>
            <Col span={24}>
              <Row style={{ marginBottom: 8 }}>
                <Col span={24}>
                  <P>หมายเหตุ</P>
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <P>{data.ShippingorderInfo.remark ? data.ShippingorderInfo.remark : '-'}</P>
                </Col>
              </Row>
            </Col>
          </Div>
        </Div>
      </Div>
      {/* ================== Footer section ================== */}
    </Div >
  )
}

export default DriverShippingDetail
export { DriverShippingDetail }
